import type { SetupFilter } from '../filter'

const SEARCH_COLUMNS = ['title', 'symbol', 'exchange', 'description']

/**
 * Case-insensitive "contains" across title, symbol, exchange and description.
 * The term is double-quoted for PostgREST so commas and parentheses in it can't break the `or` filter.
 */
// biome-ignore lint/suspicious/noExplicitAny: Supabase query builder types are highly complex
export const applyTextSearch = (query: any, filters: Pick<SetupFilter, 'search'>, prefix = '') => {
  const term = filters.search?.trim().replace(/["\\]/g, '')
  if (!term) return query

  const orString = SEARCH_COLUMNS.map((column) => `${column}.ilike."%${term}%"`).join(',')
  return prefix ? query.or(orString, { foreignTable: prefix }) : query.or(orString)
}

// biome-ignore lint/suspicious/noExplicitAny: Supabase query builder types are highly complex
export const applyFilters = (query: any, filters: SetupFilter, prefix = '') => {
  let q = query
  const p = prefix ? `${prefix}.` : ''

  if (filters.duration?.length) q = q.in(`${p}duration`, filters.duration)
  if (filters.symbols?.length) q = q.in(`${p}symbol`, filters.symbols)
  if (filters.exchanges?.length) q = q.in(`${p}exchange`, filters.exchanges)
  if (filters.assetType?.length) q = q.in(`${p}market`, filters.assetType)
  if (filters.position?.length) q = q.in(`${p}position`, filters.position)
  if (filters.stage?.length) q = q.in(`${p}stage`, filters.stage)
  if (filters.author) q = q.eq(`${p}created_by`, filters.author)

  q = applyTextSearch(q, filters, prefix)

  if (filters.patternSpecification?.length) {
    const includesNull = filters.patternSpecification.includes(null)
    const specs = filters.patternSpecification.filter(p => p !== null)

    if (specs.length > 0 && includesNull) {
      // 1. Write the OR string WITHOUT the prefix
      const orString = `pattern_specification.in.(${specs.join(',')}),pattern_specification.is.null`

      // 2. Let supabase-js apply the prefix at the OR level using foreignTable
      if (prefix) {
        q = q.or(orString, { foreignTable: prefix })
      } else {
        q = q.or(orString)
      }
    } else if (specs.length > 0) {
      q = q.in(`${p}pattern_specification`, specs)
    } else if (includesNull) {
      q = q.is(`${p}pattern_specification`, null)
    }
  }

  return q
}
